import Vue from "vue";
import Component from "vue-class-component";
import { CashboxStore } from "@/store/modules/Finance/Cashbox";
import { ICashbox } from "@/entity/finance/cashbox/cashbox.types";

@Component
export class CashBoxMix extends Vue {
    get cashBoxes(): ICashbox | null {
        return CashboxStore.items;
    }
}
